// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\RecurringBatch\ApiRecurringBatchSelf.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { RecurringBatchVersion, RecurringBatchVersionData, RecurringBatchVersionOptions } from 'data/models/RecurringBatchVersion';

// RecurringBatchSelfData is the class that RecurringBatchSelf serializes to/from
export interface RecurringBatchSelfData {
    Id : number;
	
    Events : EventData[] | null;
    Live : RecurringBatchData | null;
    Versions : RecurringBatchVersionData[] | null;
	
}

// RecurringBatchSelfOptions is the class which may be passed to the RecurringBatchSelf constructor to define optional initial data values
export interface RecurringBatchSelfOptions {
    Id : number;
	
    Events? : EventOptions[] | null;
    Live? : RecurringBatchOptions | null;
    Versions? : RecurringBatchVersionOptions[] | null;
	
}

export class RecurringBatchSelf {
    public Id : DataSignal<number>;
	
    public Events : SDataArray<Event>;
    public Live : DataSignal<RecurringBatch | null>;
    public Versions : SDataArray<RecurringBatchVersion>;
	

    constructor();
    constructor(data : RecurringBatchSelfOptions);
    constructor(data: RecurringBatchSelfOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Events = SArray<Event>([]);
        this.Live = S.value<RecurringBatch | null>(null);
        this.Versions = SArray<RecurringBatchVersion>([]);
	    
    }

    static key(obj : RecurringBatchSelf) {
        return obj.Id();
    }
    
    static dataKey(obj : RecurringBatchSelfOptions) {
        return obj.Id;
    }

    static update(obj : RecurringBatchSelf, data : RecurringBatchSelfOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/RecurringBatchSelf.ts